import { ColumnMeta, RowData } from '@tanstack/react-table';
import { IUserTableFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';

export const activeUsersTableConfig: Record<
  string,
  ColumnMeta<IUserTableFieldsFragment, RowData>
> = {
  name: {
    style: {
      flexGrow: 1,
      flexBasis: '120px',
      minWidth: '120px',
      maxWidth: '100%',
    },
  },
  email: {
    style: {
      flexGrow: 1,
      flexBasis: '120px',
      minWidth: '120px',
      maxWidth: '100%',
    },
  },
  defaultSchema: {
    style: {
      flexBasis: '110px',
      minWidth: '110px',
    },
  },
  defaultView: {
    style: {
      flexBasis: '110px',
      minWidth: '110px',
    },
  },
  roles: {
    style: {
      flexBasis: '140px',
      minWidth: '140px',
    },
  },
  status: {
    style: {
      flexBasis: '100px',
      minWidth: '100px',
    },
  },
  createdAt: {
    style: {
      flexBasis: '110px',
      minWidth: '110px',
      textAlign: 'right',
    },
    alignment: 'right',
  },
  lastLogin: {
    style: {
      flexBasis: '110px',
      minWidth: '110px',
      textAlign: 'right',
    },
    alignment: 'right',
  },
  actions: {
    style: {
      width: '20px',
      flexBasis: '20px',
    },
  },
};
